'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _colorComputed = require('./color-computed');

var _colorComputed2 = _interopRequireDefault(_colorComputed);

var _chainPattern = require('./chain-pattern');

var _chainPattern2 = _interopRequireDefault(_chainPattern);

var _colorUnitconvert = require('./color-unitconvert');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  //换肤颜色算法
  colorComputed: _colorComputed2.default,
  colorUnitConvert: function colorUnitConvert() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return _colorUnitconvert.redixDuty.exec(color);
  },

  //统一输出
  console: function console(type) {
    var _console = window.console;
    //IE8版本下下静默。eslint在生产环境已强制去除console和debugger语句
    if (!_console) return;
    _console[type].apply(null, (0, _from2.default)(arguments).slice(1));
  },

  //职责链模式
  dutyChain: function dutyChain() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    /* eslint-disable no-new */
    return new _chainPattern2.default(callback);
  },

  cookies: {
    get: function get(key) {
      var reg = new RegExp(key + '=([^;]*)');
      return document.cookie.match(reg) && document.cookie.match(reg)[1];
    },
    set: function set(key, val, lifecycle) {
      var date = new Date();
      date.setTime(date.getTime() + lifecycle * 24 * 60 * 60 * 1000);
      document.cookie = key + '=' + val + ';expires=' + date.toUTCString();
    },
    remove: function remove(key) {
      this.set(key, '', -1);
    }
  }
};